import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "prestation-info d-flex flex-column mb-0" }
const _hoisted_2 = { class: "m-0 mb-1" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "m-0 mb-1" }

import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'

  /* ------------------- Configurations & Enums ------------------- */
  import { PrestType } from '@/config'

  /* ------------------- Components ------------------- */
  import PrestationIcon from '@/assets/PrestationIcon.vue'

  /* ------------------- Types & Interfaces ------------------- */
  import { OptionSummary } from '@/services/BookingService.interface'

  /* ------------------- Props & Interfaces ------------------- */
  interface GroupedPrestation {
    name: string
    prestId: number
    count: number
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'PrestationInfo',
  props: {
    options: {}
  },
  setup(__props: any) {

  /* ------------------- Vue Core & Utilities ------------------- */
  const props = __props

  const { t } = useI18n()

  /* ------------------- Computed Properties ------------------- */
  /**
   * Filters options to include only Accomodation prestations and groups them.
   */
  const groupedPrestations = computed<GroupedPrestation[]>(() => {
    const prestationMap = new Map<string, GroupedPrestation>()

    props.options
      .filter(option => option.prestTypeId === PrestType.Accomodation) // Convert options to prestations
      .forEach(option => {
        const key = `${option.prestId}-${option.name}`
        if (prestationMap.has(key)) {
          prestationMap.get(key)!.count += 1
        } else {
          prestationMap.set(key, {
            name: option.name,
            prestId: option.prestId,
            count: 1,
          })
        }
      })

    return Array.from(prestationMap.values())
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedPrestations.value, (prestation, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: `${prestation.prestId}-${index}`
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          _createVNode(PrestationIcon, { class: "prestation-logo me-1" }),
          _createTextVNode(" " + _toDisplayString(prestation.name) + " ", 1),
          (prestation.count > 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "x" + _toDisplayString(prestation.count), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", _hoisted_4, [
          _createElementVNode("strong", null, _toDisplayString(_unref(t)('reservations.prestId')), 1),
          _createTextVNode(" " + _toDisplayString(prestation.prestId), 1)
        ])
      ])
    ]))
  }), 128))
}
}

})